import { useCallback, useState } from 'react';

import type { LayerId } from './context';

export function useLayerManagerFactory() {
  const [activeLayers, setActiveLayers] = useState(new Set<LayerId>());

  const enterLayer = useCallback((id: LayerId) => {
    setActiveLayers((current) => {
      const clone = new Set(current);
      clone.add(id);
      return clone;
    });
  }, []);

  const exitLayer = useCallback((id: LayerId) => {
    setActiveLayers((current) => {
      const clone = new Set(current);
      clone.delete(id);
      return clone;
    });
  }, []);

  return { activeLayers, exitLayer, enterLayer };
}
